
/**
 * Module dependencies.
 */

import {
  NavThemeProps,
  navTransition,
  setNavBorderColor,
  setNavColor
} from './nav-theme';
import { ifProp } from 'styled-tools';
import { navElementAttrs } from './nav-element';
import { units } from 'src/styles/utils';
import styled from 'styled-components';

/**
 * Export `NavButton` styled component.
 *
 * `Nav / Button Primary` in the design system: a pill that only shows its
 * border on hover or while its mega menu is open.
 */

const NavButton = styled.button.attrs(navElementAttrs)<NavThemeProps & {
  isActive?: boolean
}>`
  -webkit-tap-highlight-color: transparent;
  appearance: none;
  background: none;
  border: 1px solid transparent;
  border-radius: 100px;
  cursor: pointer;
  display: inline-flex;
  font-size: 14px;
  letter-spacing: 0.01em;
  line-height: 1.5;
  outline: none;
  padding: ${units(1)} ${units(1.5)};
  text-decoration: none;
  text-transform: uppercase;
  transition: ${navTransition};
  transition-property: border-color, color;
  white-space: nowrap;

  ${setNavColor}

  &:focus-visible,
  &:hover {
    ${setNavBorderColor}
  }

  ${ifProp('isActive', setNavBorderColor)}
`;

/**
 * Export `NavButton` styled component.
 */

export default NavButton;
